import { IStorageAccessor } from 'util/domain';
import { 
    Menu,
    MenuItemConfig,
    ViewType,
    SortType,
    IMenuItem,
    MenuItemContext,
    MenuPriority
} from 'sharebase/domain';
import { MenuItemFactory } from 'sharebase/factories';

export type SortArgs = {
    type: SortType, 
    ascending:boolean
}
/**
* @ngdoc service
* @name  sharebase-app.sbaToolbarService
* 
* @description 
* A service used to retrieve and interact with ShareBase app 
* content toolbar
* 
**/
export class ToolbarService extends Menu {
    public static $inject = [
        '$q',
        'localStorageService',
        'sbMenuItemFactory'
    ];
    
    private savedFolderViewType = this.localStorageService.getStoredValue('sba_user_viewType') === 'list' ? 'list' : 'card';
    private _views:ViewType[] = [];
    private _activeView:ViewType;
    private _smartViewEnabled:Boolean = false;
    private _sort:SortArgs  =  {
        type: this.localStorageService.getStoredValue('sba_user_sortType') !== '' ? this.localStorageService.getStoredValue('sba_user_sortType') as SortType: 'Name',
        ascending: this.localStorageService.getStoredValue('sba_user_sortAscending') === 'false' ? false : true
    };
    private _target:any;

    get sortType() { return this._sort; }
    /**
    * @ngdoc property
    * @name sbaToolbarService#actionTarget
    * @propertyOf sharebase-app.sbaToolbarService
    * @kind property
    *
    * @description
    * The target for toolbar actions
    *
    * @returns {string} value of target 
    */
    public set actionTarget(val){
        this._target = val;
        this.getActiveItems();
    } 
    public get actionTarget() {
        return this._target;
    }
    public set smartViewEnabled(val:Boolean){
        this._smartViewEnabled = val;
    } 
    public get smartViewEnabled() {
        return this._smartViewEnabled;
    }
    public get showAllActions(){
        return Object.keys(this.items).filter(i=>{ return this.items[i].visible;}).length < 5;
    }
    public get views(){
        return this._views;
    }
    public addView(newView:ViewType){
        this._views.push(newView);

        if(!this._activeView && newView.name === this.savedFolderViewType){
            //set the added view as the active view
            this._activeView = angular.copy(newView);
        }
    }
    public removeView(removeView:ViewType){
        let index = this.views.indexOf(removeView);
        this.views.splice(this.views.indexOf(removeView),1);

        if(this._activeView && removeView.name === this.savedFolderViewType){
            //unset active view if it's removed
            this._activeView= null;
        }
    }
    public clearViews(){
        this._views = [];
        this._smartViewEnabled = false;
        this._activeView= null;
    }

    public breadCrumbs = [];

    /**
    * @ngdoc property
    * @name sbaToolbarService#viewType
    * @propertyOf sharebase-app.sbaToolbarService
    * @kind property
    *
    * @description
    * Content view style to be used
    *
    * @returns {string} value of the view type 
    * 
    */
    public get viewType() { return this._activeView; }
    /**
    * @ngdoc property
    * @name sbaToolbarService#viewType
    * @propertyOf sharebase-app.sbaToolbarService
    * @kind property
    *
    * @description
    * Set the content view style
    *
    * @returns {ViewType} value of the view type 
    * @param {ViewType} val View type to assign to content 
    * 
    */
    public set viewType(view:ViewType) {
        this._activeView = view;
        if(this._activeView.remember){
            this.localStorageService.setStoredValue('sba_user_viewType', this._activeView.name);
            this.savedFolderViewType = this._activeView.name;
        }        
    }
    
    public get disableViewOptions(){return this.views.length <2 };
    /**
    * @ngdoc property
    * @name sbaToolbarService#title
    * @propertyOf sharebase-app.sbaToolbarService
    * @kind property
    *
    * @description
    * Title assigned to content toolbar
    *
    * @returns {string} value of title 
    * 
    */
    public title:string = '';   

    constructor(
        protected readonly $q: ng.IQService, 
        private readonly localStorageService:IStorageAccessor, 
        sbMenuItemFactory:MenuItemFactory
    ){
        super($q, sbMenuItemFactory);
    }
        
    public setSortType(val) {
        if (val === this._sort.type) {
            this._sort.ascending = !this._sort.ascending;
            this.localStorageService.setStoredValue('sba_user_sortAscending', this._sort.ascending.toString());
        } else {				
            this._sort.type = val;
            this._sort.ascending = true;
            this.localStorageService.setStoredValue('sba_user_sortType', this._sort.type);
            this.localStorageService.setStoredValue('sba_user_sortAscending', this._sort.ascending.toString());
        }

        return this;
    }

    public add(config:MenuItemConfig, priority?:MenuPriority) {        
        super.add(config, priority);
        return this.addItem(this.getItem(config.action));
    }

    public addItem(item:IMenuItem, priority?:MenuPriority){
        item.context = MenuItemContext.Toolbar;
        return super.addItem(item, priority);
    }

    public clear(){
        super.clear();
        this.breadCrumbs = [];
        this.actionTarget = null;
    }

    public getActiveItems(target?:any) {
        target = target || this.actionTarget;
        return super.getActiveItems(target);
    }   
}


// WEBPACK FOOTER //
// ./src/sharebase-app/services/appToolBarService.ts